import { render } from "./Setting.vue?vue&type=template&id=693efbba"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"
script.render = render

export default script